module.exports = __webpack_public_path__ + "img/highSpeedRail-1.08026cba.jpg";